import React, { useEffect } from 'react'
import { useQuery } from 'react-query'

import { useChapterAction } from '@hooks/chapter/useChapterAction'
import { useAuthentication } from '@hooks/useAuthentication'
import { useAccordion } from '@components/Accordion/withAccordion'
import { ChapterGroupItemProps, WithChapterGroupItemProps } from './interface'

export function withChapterGroupItem(
  Component: React.FC<ChapterGroupItemProps>
) {
  function WithChapterGroupItem({
    bookId,
    page,
    totalChapter,
    bookName,
    bookType,
    bookCategory,
    bookReadPromotionDetail,
    sorter,
    isOwner,
    isDrawer,
    isManga,
    canAction,
    isSelect,
    selectedChapters,
    handleSelectChapter,
    onLoad,
  }: WithChapterGroupItemProps) {
    const chapterClient = useChapterAction()
    const { canFetchApi } = useAuthentication()
    const { active } = useAccordion()

    const { data, isLoading } = useQuery(
      ['book', bookId, 'chapter-reader', page],
      () => chapterClient.bookChaptersReaderPaginate(bookId, page),
      { enabled: canFetchApi && active }
    )

    useEffect(() => {
      if (data) {
        onLoad?.(data)
      }
    }, [data])

    const componentProps = {
      data,
      page,
      totalChapter,
      bookId,
      bookName,
      bookType,
      bookCategory,
      bookReadPromotionDetail,
      sorter,
      isLoading,
      isOwner,
      isDrawer,
      isManga,
      isSelect,
      selectedChapters,
      handleSelectChapter,
      canAction,
    }
    return <Component {...componentProps} />
  }
  return WithChapterGroupItem
}
